export * from './ngs-reveal.directive';
export * from './ngs-reveal-set.directive';
export * from './ngs-reveal-common.directive';

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
